import React from 'react';
import { Box } from '@mui/material';
import { LegalLinks } from '../legalLinks/legalLinks.component';
import styles from './publicFooter.module.css';

/**
 * Footer for the pages served before login. The documents have to be reachable
 * before anyone concludes a contract, so this renders on the landing, login and
 * registration screens.
 */
export const PublicFooter = () => {
  return (
    <Box component="footer" className={styles.publicFooter}>
      <LegalLinks />
      <span className={styles.copyright}>© {new Date().getFullYear()} Copigo</span>
    </Box>
  );
};
